import React, { HTMLAttributes } from "react";
import StyledCardImage from "./CardImage.styled";

export type ICardImage = HTMLAttributes<HTMLImageElement>;

const CardImage = StyledCardImage;

export default CardImage;
